import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../components/ToastMsg";
import "react-loading-skeleton/dist/skeleton.css";
import styles from './index.module.css';
import TableSkeleton from "../../../../components/Skeleton";
import NoResultsFound from "../../../../components/NoResultsFound";
import Modal from "../../../../components/Modal";
import { faCircleCheck, faCircleXmark, faDownload, faEye, faPen, faPenToSquare, faXmark } from "@fortawesome/free-solid-svg-icons";
import { downloadAllCertificates, editCertificate, editCertificateBulkStatus, editCertificateVersion, getAllCertificates, getAllCertificatesToBulkDownload } from "../../../../redux/features/certificate/certificateService";
import { getAllActiveCourses } from "../../../../redux/features/course/courseService";
import FilterDropdown from "../../../../components/FilterDropdown";
import SearchBarRow from "../../../../components/SearchBarRow";
import Certificate from "../../../../components/Certificate/IBSUCertificate/IBSUOther";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import QRCode from "qrcode";
import BeatLoader from "react-spinners/BeatLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { parse } from "date-fns";
import { useNavigate } from "react-router-dom";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { selectActiveCertificateList } from "../../../../redux/features/certificateEntity/certificateEntitySlice";
import { selectActiveCertificateTypesList } from "../../../../redux/features/certificateType/certificateTypeSlice";
import { getActiveCertificateTypes } from "../../../../redux/features/certificateType/certificateTypeService";
import { getCertificateTemplatesByType } from "../../../../redux/features/certificateTemplate/certificateTemplateService";
import IBSUOfficialCertificate from "../../../../components/Certificate/IBSUCertificate/IBSUOfficial";
import IBSCOfficialCertificate from "../../../../components/Certificate/IBSCCertificate/IBSCOfficial";
import CDCCertificate from "../../../../components/Certificate/CDCCertificate/CDCOther";
import { LuLogs } from "react-icons/lu";
import { LuPrinterCheck } from "react-icons/lu";
import RCCertificate from "../../../../components/Certificate/RCCertificate/RCCOther";

const QR_Link = process.env.REACT_APP_PUBLIC_QR_LINK;

const certificateStatus = [
    { id: '1', name: 'Pending' },
    { id: '2', name: 'Verified' },
    { id: '3', name: 'Printed' },
    { id: '4', name: 'Issued' },
    { id: '5', name: 'ReIssued' },
    { id: '6', name: 'Cancelled' }
];

const limitSize = [
    { index: 0, name: '10', value: 10 },
    { index: 1, name: '20', value: 20 },
    { index: 2, name: '50', value: 50 },
    { index: 3, name: '100', value: 100 },
    { index: 4, name: 'Unlimited', value: 1 },
];

const OFFICIAL_HEADERS = [
    "student_name",
    // "program",
    "completion_date",
    "issued_date",
    "certificate_issue_year"
];

const OTHER_HEADERS = [
    "student_name",
    "certificate_phrase_1",
    "certificate_phrase_2",
    "certificate_phrase_3",
    "other_course",
    "conducted_by_phrase",
    "conducted_by",
    "completion_date",
    "completion_phrase",
    "issued_date",
    "certificate_issue_year",
    "signature_name_1",
    "signature_designation_1",
    "signature_name_2",
    "signature_designation_2"
];

const convertToDate = (dateString) => {
    // Remove ordinal suffixes (st, nd, rd, th)
    const cleanedDate = dateString.replace(/(\d+)(st|nd|rd|th)/, "$1");

    // Convert string to Date object
    return parse(cleanedDate, "d MMMM yyyy", new Date());
};

const CertificateList = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const entityDropdownRef = useRef(null);
    const courseDropdownRef = useRef(null);
    const typeDropdownRef = useRef(null);
    const templateDropdownRef = useRef(null);
    const statusDropdownRef = useRef(null);
    const editStatusDropdownRef = useRef(null);
    const bulkStatusDropdownRef = useRef(null);

    const { isCertificatesLoading, pageCount, certificates } = useSelector((state) => state.certificate.allCertificates);
    const { isEditingCertificate } = useSelector((state) => state.certificate.editedCertificate);
    const { status, data: activeCertificateEntities } = useSelector(selectActiveCertificateList);
    const { data: certificateTypes } = useSelector(selectActiveCertificateTypesList);
    const { activeCourses } = useSelector((state) => state.course.allActiveCourses);

    const [searchQuery, setSearchQuery] = useState('');

    const [selectedCountryId, setSelectedCountryId] = useState(null);
    const [isActivateModalOpen, setActivateModalOpen] = useState(false);
    const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState({
        id: '',
        name: ''
    });
    const [selectedStatus, setSelectedStatus] = useState({
        id: '',
        name: ''
    });
    const [selectedEditStatus, setSelectedEditStatus] = useState({
        id: '',
        name: ''
    });
    const [selectedBulkStatus, setSelectedBulkStatus] = useState({
        id: '',
        name: ''
    });
    const [clickedStatus, clickStatus] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingCertificateId, setLoadingCertificateId] = useState(null);

    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedCertificate, setSelectedCertificate] = useState(null);
    const [initialCertificate, setInitialCertificate] = useState(null);
    const [editErrorMsgs, setEditErrorMsgs] = useState({
        name: '',
        course_code: ''
    });
    const [disabledEditBtn, setEditBtnDisable] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);

    const [completionDate, setCompleteDate] = useState(new Date());
    const [certificateDate, setCertificateDate] = useState(new Date());
    const [selectedCertificateId, setSelectedCertificateId] = useState(null);
    const [isBulkGenerating, setBulkGenerating] = useState(false);
    const [higherStatuses, setHigherStatuses] = useState([]);

    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [pageLimit, setPageLimit] = useState(10);

    const [entityCourses, setEntityCourses] = useState([]);
    const [certificateTemplates, setCertificateTemplates] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState({
        id: '',
        name: ''
    });
    const [selectedType, setSelectedType] = useState({
        id: '',
        name: ''
    });
    const [selectedTemplate, setSelectedTemplate] = useState({
        id: '',
        name: ''
    });

    const [templateLoadng, setTemplateLoading] = useState(false);
    const [batch, setBatch] = useState('');

    const fetchDetails = useCallback(() => {
        dispatch(getAllActiveCourses());
        dispatch(getActiveCertificateTypes());
    }, [dispatch]);

    useEffect(() => {
        fetchDetails();
    }, [fetchDetails]);

    const handleSelect = (option) => {
        setSelectedCourse({
            id: option.id,
            name: option.name
        });
    };

    const handleType = async (option) => {
        setTemplateLoading(true);
        setCertificateTemplates([]);
        setSelectedTemplate({ id: '', name: '' })
        setSelectedType({
            id: option.id,
            name: option.name,
        });
        const response = await dispatch(getCertificateTemplatesByType({ id: option.id })).unwrap();
        setCertificateTemplates(response);
        setTemplateLoading(false);
    };

    const handleTemplate = (option) => {
        setSelectedTemplate({
            id: option.id,
            name: option.name
        });
    };

    const handleSelectBulkStatus = (option) => {
        setSelectedBulkStatus({
            id: option.id,
            name: option.name
        });
        clickStatus(true);
    };
    const fetchAllCertificates = useCallback(
        (filters = {}) => {
            const params = {
                search: searchQuery,
                course_id: selectedCourse.id,
                ...(pageLimit !== 1 && { skip: (currentPage - 1) }),
                limit: pageLimit,
                status: selectedStatus.name,
                certificate_entity_id: selectedEntity.id,
                batch: batch,
                certificate_type_id: selectedType.id,
                certificate_template_id: selectedTemplate.id,
                ...filters,
            };
            dispatch(getAllCertificates(params));
        },
        [dispatch, searchQuery, selectedStatus, selectedEntity, selectedCourse, currentPage, pageLimit, batch, selectedType, selectedTemplate]
    );

    const fetchBulkCertificates = useCallback(
        (filters = {}) => {
            const params = {
                course_id: selectedCourse.id,
                status: selectedStatus.name,
                ...filters,
            };
            dispatch(getAllCertificatesToBulkDownload(params));
        },
        [dispatch, selectedStatus, selectedCourse]
    );


    useEffect(() => {
        fetchAllCertificates();
        setBulkStatusError('');
    }, [fetchAllCertificates]);

    const handleSelectStatus = (option) => {
        setSelectedStatus({
            id: option.id,
            name: option.name
        });
        setCurrentPage(1);
    };

    const closeModal = () => setActivateModalOpen(false);
    const closDeactivationModal = () => setDeactivationModalOpen(false);

    const handleYes = async () => {
        setActivateModalOpen(false);
        try {
            const response = await dispatch(editCertificate({ id: selectedCountryId, status: true })).unwrap();
            setSelectedCountryId(null);
            showToast('success', response.message);
            fetchAllCertificates();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }
    const handleRejectYes = async () => {
        setDeactivationModalOpen(false);
        try {
            const response = await dispatch(editCertificate({ id: selectedCountryId, status: false })).unwrap();
            setSelectedCountryId(null);
            showToast('success', response.message);
            fetchAllCertificates();
        }
        catch (error) {
            showToast('error', error.message);
        };
    }

    // const previewCertificate = async (certificate) => {
    //     navigate("/admin/preview-certificate", { state: { certificate } })
    // }
    const previewCertificate = (certificate) => {
        const url = `/admin/certificates/preview-certificate/${certificate.id}`;
        window.open(url, "_blank", "noopener,noreferrer");
    };

    const openCertificate = async (certificate) => {
        try {
            setLoadingCertificateId(certificate.id);
            const qrDataUrl = await QRCode.toDataURL(
                `${QR_Link}/?ref=${certificate.document_ref}`,
                // `http://localhost:3000/document_ref/${certificate.document_ref}`,
                { width: 100 }
            );
            if (certificate?.certificate_template?.name === 'IBSU Offical Certificate') {
                const pdfBlob = await pdf(<IBSUOfficialCertificate data={[certificate, qrDataUrl]} />).toBlob();
                const pdfUrl = URL.createObjectURL(pdfBlob);
                window.open(pdfUrl, "_blank");
            }
            if (certificate?.certificate_template?.name === 'IBSC Official Certificate') {
                const pdfBlob = await pdf(<IBSCOfficialCertificate data={[certificate, qrDataUrl]} />).toBlob();
                const pdfUrl = URL.createObjectURL(pdfBlob);
                window.open(pdfUrl, "_blank");
            }
            //  if (certificate?.certificate_template?.name === 'RC Other Certificate') {
            //     const pdfBlob = await pdf(<RCCertificate data={[certificate, qrDataUrl]} />).toBlob();
            //     const pdfUrl = URL.createObjectURL(pdfBlob);
            //     window.open(pdfUrl, "_blank");
            // } 
            if ((certificate?.certificate_template?.name !== 'IBSU Offical Certificate') && (certificate?.certificate_template?.name !== 'IBSC Official Certificate')) {
                const pdfBlob = await pdf(<CDCCertificate data={[certificate, qrDataUrl]} />).toBlob();
                const pdfUrl = URL.createObjectURL(pdfBlob);
                window.open(pdfUrl, "_blank");
            }
        } catch (error) {
            showToast(
                "error",
                "An error occurred while generating the PDF. Please try again."
            );
        } finally {
            setLoadingCertificateId(null);
        }
    }

    // Edit certificate
    const handleSelectedCertificateChange = (e) => {
        const { name, value } = e.target;
        setErrorMsg(null);
        setSelectedCertificate((prev) => ({
            ...prev,
            [name]: value,
        }));

        setEditErrorMsgs((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const isValidEditCertificate = () => {
        const errors = {};
        const trimmedName = selectedCertificate.student_name.trim();

        if (!trimmedName) {
            errors.student_name = "Name is required.";
        }
        if (Object.keys(errors).length > 0) {
            setEditErrorMsgs(errors);
            return false;
        } else {
            return true;
        }
    };

    // function getChangedValues(selectedData, completeDate, certificateDate) {
    //     const changedValues = {};
    //     const keysToCheck = ['student_name', 'completion_date', 'issued_date', 'certificate_status'];

    //     for (const key of keysToCheck) {
    //         let newValue = selectedData[key];

    //         // Use the provided completeDate and certificateDate if checking these fields
    //         if (key === 'completion_date' && completeDate !== initialCertificate[key]) {
    //             changedValues[key] = completeDate;
    //         } if (key === 'issued_date' && certificateDate !== initialCertificate[key]) {
    //             changedValues[key] = certificateDate;
    //         } if (key === 'student_name' && newValue !== initialCertificate[key]) {
    //             changedValues[key] = newValue;
    //         }
    //     }

    //     // Ensure `id` is always included
    //     if (selectedData.id) {
    //         changedValues.id = selectedData.id;
    //     }

    //     return changedValues;
    // }
    function getChangedValues(selectedData) {
        const changedValues = {};
        for (const key in selectedData) {
            if (
                key !== 'id' &&
                selectedData.hasOwnProperty(key) &&
                selectedData[key] !== initialCertificate[key]
            ) {
                changedValues[key] = selectedData[key];
            }

            if (key === 'id') {
                changedValues[key] = selectedData[key];
            }
        }
        return changedValues;
    }

    const formatDateWithSuffix = (date) => {
        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "long" });
        const year = date.getFullYear();

        // Function to add ordinal suffix
        const getOrdinalSuffix = (num) => {
            if (num > 3 && num < 21) return "th"; // 11th, 12th, 13th...
            switch (num % 10) {
                case 1: return "st"; // 1st
                case 2: return "nd"; // 2nd
                case 3: return "rd"; // 3rd
                default: return "th"; // 4th, 5th, 6th...
            }
        };

        return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
    };

    const handleSelectEditStatus = (option) => {
        setSelectedEditStatus({
            id: option.id,
            name: option.name
        });
    };

    const editCertificateDetails = async () => {
        // const completeData = formatDateWithSuffix(completionDate);
        // if (selectedCertificate.completion_date !== completeData) {
        //     setSelectedCertificate(prevState => ({
        //         ...prevState,
        //         completion_date: completeData
        //     }));
        // }
        // const certificateData = formatDateWithSuffix(certificateDate);
        // if (selectedCertificate.issued_date !== certificateData) {
        //     setSelectedCertificate(prevState => ({
        //         ...prevState,
        //         issued_date: certificateData
        //     }));
        // }
        if (isValidEditCertificate(selectedCertificate.student_name)) {
            const data = getChangedValues(selectedCertificate);
            const hasChanges = Object.keys(data).some(key => key !== 'id');
            if (!hasChanges) {
                setErrorMsg('There are no changes to update.');
            } else {
                setEditBtnDisable(true);
                try {
                    const response = await dispatch(editCertificate(data)).unwrap();
                    setEditBtnDisable(false);
                    setSelectedCertificate(null);
                    setInitialCertificate(null);
                    setModalOpen(false);
                    showToast('success', response.message);
                    fetchAllCertificates();
                }
                catch (error) {
                    setEditBtnDisable(false);
                    showToast('error', error.message);
                };
            }
        }
    };

    const editCertificateStatus = async () => {
        setEditBtnDisable(true);
        try {
            if (selectedEditStatus.name === 'Cancelled') {
                if (reason === '') {
                    setReasonMsg('Reason is required.');
                } else {
                    const response = await dispatch(editCertificate({ id: selectedCertificateId, certificate_status: selectedEditStatus.name, reason: reason })).unwrap();
                    setEditBtnDisable(false);
                    setSelectedCertificate(null);
                    setInitialCertificate(null);
                    setPrintModalOpen(false);
                    showToast('success', response.message);
                    fetchAllCertificates();
                }
            } else {
                const response = await dispatch(editCertificate({ id: selectedCertificateId, certificate_status: selectedEditStatus.name })).unwrap();
                setEditBtnDisable(false);
                setSelectedCertificate(null);
                setInitialCertificate(null);
                setPrintModalOpen(false);
                showToast('success', response.message);
                fetchAllCertificates();
            }
        }
        catch (error) {
            setEditBtnDisable(false);
            showToast('error', error.message);
        };
    };
    //Certificate status
    const [printModalOpen, setPrintModalOpen] = useState(false);

    const handleClearFilters = () => {
        if (statusDropdownRef.current) {
            statusDropdownRef.current.clearSelection();
        }
        if (entityDropdownRef.current) {
            entityDropdownRef.current.clearSelection();
        }
        if (courseDropdownRef.current) {
            courseDropdownRef.current.clearSelection();
        }
        if (typeDropdownRef.current) {
            typeDropdownRef.current.clearSelection();
        }
        if (templateDropdownRef.current) {
            templateDropdownRef.current.clearSelection();
        }
        setSelectedStatus({ id: '', name: '' });
        setSelectedEntity({ id: '', name: '' });
        setSelectedCourse({ id: '', name: '' });
        setSelectedType({ id: '', name: '' });
        setSelectedTemplate({ id: '', name: '' });
        setSearchQuery("");
    };

    const downloadBulk = async (certificates) => {
        setBulkGenerating(true);
        try {
            if (!certificates.length) {
                return;
            }

            const zip = new JSZip();
            const pdfPromises = certificates.map(async (cert) => {
                const qrDataUrl = await QRCode.toDataURL(
                    `${QR_Link}/?ref=${cert.document_ref}`,
                    { width: 100 }
                );
                if (cert?.certificate_template?.name === 'IBSU Offical Certificate') {
                    const pdfBlob = await pdf(<IBSUOfficialCertificate data={[cert, qrDataUrl]} />).toBlob();
                    zip.file(`Certificate_${cert.document_ref}.pdf`, pdfBlob);
                }
                if (cert?.certificate_template?.name === 'IBSC Official Certificate') {
                    const pdfBlob = await pdf(<IBSCOfficialCertificate data={[cert, qrDataUrl]} />).toBlob();
                    zip.file(`Certificate_${cert.document_ref}.pdf`, pdfBlob);
                } if ((cert?.certificate_template?.name !== 'IBSU Offical Certificate') && (cert?.certificate_template?.name !== 'IBSC Official Certificate')) {
                    const pdfBlob = await pdf(<CDCCertificate data={[cert, qrDataUrl]} />).toBlob();
                    zip.file(`Certificate_${cert.document_ref}.pdf`, pdfBlob);
                }
                // const pdfBlob = await pdf(<Certificate data={[cert, qrDataUrl]} />).toBlob();
                // zip.file(`Certificate_${cert.document_ref}.pdf`, pdfBlob);
            });

            await Promise.all(pdfPromises);
            zip.generateAsync({ type: "blob" }).then((zipBlob) => {
                saveAs(zipBlob, "Certificates.zip");
            });
            if (selectedStatus.name === 'Approved') {
                await Promise.all(certificates.map(cert =>
                    dispatch(editCertificate({ id: cert.id, certificate_status: 'Printed' })).unwrap()
                ));
            }
            fetchAllCertificates();
            setBulkGenerating(false);
        } catch (error) {
            showToast('error', error.message);
            setBulkGenerating(false);
        }
    }
    const [reason, setReason] = useState('');

    const [reasonMsg, setReasonMsg] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setReason(value);
        setReasonMsg('');
    };

    const handleChangeStatusClick = (certificate) => {
        setBulkStatusError('');
        setSelectedCertificateId(certificate.id);

        const currentStatus = certificateStatus.find(status => status.name === certificate.certificate_status);

        if (currentStatus) {
            setSelectedEditStatus(currentStatus);
            const filteredStatuses = certificateStatus.filter(
                status => parseInt(status.id) > parseInt(currentStatus.id)
            );

            setHigherStatuses(filteredStatuses);
        } else {
            setHigherStatuses([]);
        }

        setPrintModalOpen(true);
    };

    const handleRowSelect = (id) => {
        setBulkStatusError('');
        setSelectedRows((prev) => {
            const updated = prev.includes(id)
                ? prev.filter((rowId) => rowId !== id)
                : [...prev, id];

            // Sync Select All
            setSelectAll(updated.length === certificates.length);

            return updated;
        });
    };

    const handleSelectAll = () => {
        setBulkStatusError('');
        if (selectAll) {
            setSelectedRows([]);
            setSelectAll(false);
        } else {
            const allIds = certificates.map((c) => c.id);
            setSelectedRows(allIds);
            setSelectAll(true);
        }
    };

    const [bulkStatusError, setBulkStatusError] = useState('');
    const [disabledBulkSubmit, setDisabledBulkSubmit] = useState(false);

    const bulkActionSubmit = async () => {
        if (selectedRows.length === 0) {
            setBulkStatusError('Please select certificates.');
        } else {
            try {
                setDisabledBulkSubmit(true);
                const data = {
                    certificate_status: selectedBulkStatus.name,
                    certificate_ids: selectedRows
                }
                const response = await dispatch(editCertificateBulkStatus(data)).unwrap();
                setDisabledBulkSubmit(false);
                fetchAllCertificates();
                setSelectedRows([]);
                setSelectAll(false);
                showToast('success', response.message);
            } catch (error) {
                setDisabledBulkSubmit(false);
                fetchAllCertificates();
                setSelectedRows([]);
                setSelectAll(false);
                showToast('error', error.message);
            }
        }
    }

    // Activity logs
    const getCertificateActivityLogs = async (certificate) => {
        navigate(`/admin/certificates/activity-logs/${certificate.id}`)
    };

    const handleLimit = async (option) => {
        setPageLimit(option);
    };

    const [selectedReprintCertificate, setSelectReprintCertificate] = useState(null);
    const [isCertificateReprintModalOpen, setCertificateReprintModalOpen] = useState(false);

    const [isCertificateReprintConfirmationModalOpen, setCertificateReprintConfirmationModalOpen] = useState(false);
    const [isChanging, setChanging] = useState(false);
    const [isPrinting, setPrinting] = useState(false);


    const handleReprintYes = async () => {
        setChanging(true);
        try {
            await dispatch(editCertificateVersion({ id: selectedReprintCertificate.id })).unwrap();
            fetchAllCertificates();
            setCertificateReprintModalOpen(false);
            setCertificateReprintConfirmationModalOpen(true);
            setChanging(false);
        }
        catch (error) {
            setCertificateReprintModalOpen(false);
            setChanging(false);
            showToast('error', error.message);
        };
    }

    const handleReprintConfirmationYes = async () => {
        setPrinting(true);
        const certificateToOpen = certificates.find(
            (certificate) => certificate.id === selectedReprintCertificate?.id
        );

        if (certificateToOpen) {
            openCertificate(certificateToOpen);
            setPrinting(false);
            setCertificateReprintConfirmationModalOpen(false);
        }
    };

    // Download report
    const downloadCertificateReport = async () => {
        try {
            const params = {
                search: searchQuery,
                course_id: selectedCourse.id,
                status: selectedStatus.name,
                certificate_entity_id: selectedEntity.id,
                batch: batch,
                certificate_type_id: selectedType.id,
                certificate_template_id: selectedTemplate.id,
            };
            await dispatch(downloadAllCertificates(params)).unwrap()
        } catch (error) {
            showToast('error', 'Failed to download the file.')
        }
    }

    const isOfficialCertificate =
        selectedCertificate?.certificate_template?.name === "IBSU Offical Certificate" ||
        selectedCertificate?.certificate_template?.name === "IBSC Official Certificate";

    const activeHeaders = isOfficialCertificate
        ? OFFICIAL_HEADERS
        : OTHER_HEADERS;

    return (
        <>
            <div className={`search-card`}>
                <div className={`search-card-header`}>
                    <h1 className={`form-title`}>Certificate List
                        {certificates?.length > 0 &&
                            <FontAwesomeIcon icon={faDownload} onClick={downloadCertificateReport} className={styles.downloadBtn} />
                        }</h1>
                </div>
                <div className={styles.searchSec}>
                    <div className={`form-input-row ${styles.rowFullWidth}`}>
                        <div className={`form-input-group`}>
                            <FilterDropdown
                                ref={statusDropdownRef}
                                options={certificateStatus}
                                placeholder="Choose a Status"
                                onSelect={handleSelectStatus}
                                value={selectedStatus.name}
                            />
                        </div>
                        <div className={`form-input-group`}>
                            <SearchBarRow onSearch={(query) => setSearchQuery(query)} />
                        </div>
                        {/* <div className={styles.clearButton} onClick={handleClearFilters}>
                            <FontAwesomeIcon icon={faCircleXmark} /> <span>Clear All</span>
                        </div> */}
                    </div>
                </div>
                <div className={styles.searchSec}>
                    <div className={`form-input-row ${styles.rowFullWidth}`}>
                        <div className={`form-input-group`}>
                            <FilterDropdown
                                ref={typeDropdownRef}
                                options={certificateTypes}
                                placeholder='Select a Type'
                                onSelect={handleType}
                                value={selectedType.name}
                            /></div>
                        <div className={`form-input-group`}>
                            {selectedType.id !== '' && !templateLoadng && <FilterDropdown
                                ref={templateDropdownRef}
                                options={certificateTemplates}
                                placeholder='Select a Template'
                                onSelect={handleTemplate}
                                value={selectedTemplate.name}
                            />}
                        </div>
                    </div>
                </div>
                {selectedType?.name === 'OFFICIAL' && <div className={styles.searchSec}>
                    <div className={`form-input-row ${styles.rowFullWidth}`}>
                        <div className={`form-input-col md-col`}>
                            <FilterDropdown
                                ref={courseDropdownRef}
                                options={activeCourses}
                                placeholder="Select a Course"
                                onSelect={handleSelect}
                                value={selectedCourse.name}
                            />
                        </div>
                    </div>
                </div>}
                <div className={`form-input-row ${styles.rowWidth}`}>
                    {/* <div className={`form-input-col md-col`}> */}
                    {certificates.length > 0 &&
                        <div className={`form-input-group ${styles.actionValue}`}>
                            <FilterDropdown
                                ref={bulkStatusDropdownRef}
                                options={certificateStatus}
                                placeholder="Choose an Action"
                                onSelect={handleSelectBulkStatus}
                                value={selectedBulkStatus.name}
                            />
                            {/* {bulkStatusError &&
                                <p className={`text-danger`}>{bulkStatusError}</p>
                            } */}
                        </div>
                    }
                    {/* </div> */}
                    {clickedStatus && certificates.length > 0 &&
                        <div className={`form-input-col ${styles.fixedWidthCol}`}>
                            <div className={`form-input-group`}>
                                <button className={`btn-primary ${styles.submitBtn}`}
                                    type='button'
                                    disabled={disabledBulkSubmit}
                                    onClick={bulkActionSubmit}>
                                    {disabledBulkSubmit ? <BeatLoader color="#FFFFFF" /> : `Submit`}
                                </button>
                            </div>
                        </div>
                    }
                    <div className={`form-input-col md-col`}>
                        <div className={`form-input-group`}>
                            {(['Approved', 'Pending', 'Verified'].includes(selectedStatus.name) && certificates.length > 0) ? (
                                <button className={`btn-primary  ${styles.donwloadBtn}`}
                                    type="button"
                                    onClick={() => {
                                        downloadBulk(certificates);
                                    }}>
                                    {isBulkGenerating ? (
                                        <BeatLoader color="#FFFFFF" />
                                    ) : (
                                        <>
                                            Bulk Download <FontAwesomeIcon icon={faDownload} />
                                        </>
                                    )}
                                </button>
                            ) : null}
                        </div>
                    </div>
                    <div className={`form-input-col md-col`}>
                        <div className={`form-input-group`}>
                            {certificates.length > 0 &&
                                <div className={styles.btnGroup}>
                                    {limitSize.map((limit) => (
                                        <div key={limit.index} className={pageLimit === limit.value ? styles.activeBtn : styles.limitBtn} onClick={() => handleLimit(limit.value)}>{limit.name}</div>
                                    ))}
                                </div>
                            }
                        </div>
                    </div>
                </div>         <div className={`form-input-row ${styles.rowWidth}`}>
                    {bulkStatusError &&
                        <p className={`text-danger`}>{bulkStatusError}</p>
                    }
                </div>
                <div className={`search-card-body`}>
                    {isCertificatesLoading ?
                        <TableSkeleton columns={[<label className={styles.checkboxWrapper}>
                            <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={handleSelectAll}
                                className={styles.hTick}
                            />
                        </label>, "Document Ref", "Student Id", "Name", "Course", "Status", "Batch", "Actions"]} rowCount={10} height={20} />
                        : certificates.length > 0 ?
                            <div className={`table-container`}>
                                <table className={`table`}>
                                    <thead className={`thead`}>
                                        <tr>
                                            <th className={styles.theadColumnTick}>
                                                <label className={styles.checkboxWrapper}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectAll}
                                                        onChange={handleSelectAll}
                                                        className={styles.hTick}
                                                    />
                                                </label>
                                            </th>
                                            <th>Document Ref</th>
                                            <th>Student Id</th>
                                            <th>Name</th>
                                            <th>Course</th>
                                            <th>Status</th>
                                            <th>Batch</th>
                                            <th style={{ paddingLeft: '10px' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className={`tbody`}>
                                        {certificates?.map((certificate) => (
                                            <tr key={certificate.id} className={selectedRows.includes(certificate.id) ? `${styles.selectedRow}` : ''}>
                                                <td className={styles.theadColumnTick}>
                                                    <label className={styles.checkboxWrapper}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedRows.includes(certificate?.id)}
                                                            onChange={() => handleRowSelect(certificate?.id)}
                                                            className={styles.hTick}
                                                        />
                                                    </label>
                                                </td>
                                                <td>
                                                    {certificate?.document_ref}
                                                </td>
                                                <td>
                                                    {certificate?.student?.student_id}
                                                </td>
                                                <td>
                                                    {certificate?.student_name}
                                                </td>
                                                <td>
                                                    {certificate?.course_batch?.course?.name || certificate?.other_course}
                                                </td>
                                                <td>{certificate?.certificate_status}</td>
                                                <td>{certificate?.batch ? certificate?.batch : certificate?.course_batch?.name || certificate?.certificate_entity_batch?.name || '-'}</td>
                                                <td className={`actionsBtn ${styles.tableBtnSec}`} style={{ paddingLeft: '10px' }}>
                                                    <button className={`btn-edit-label`} onClick={() => previewCertificate(certificate)}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </button>
                                                    {['Verified', 'Printed', 'Issued', 'ReIssued'].includes(certificate?.certificate_status) &&
                                                        <button className={`btn-edit-secondary`} onClick={() => openCertificate(certificate)}>
                                                            {loadingCertificateId === certificate.id ? <BeatLoader color='#474747' size={5} /> : <FontAwesomeIcon icon={faDownload} />}
                                                        </button>}
                                                    {['Pending'].includes(certificate?.certificate_status) &&
                                                        <button className={`btn-edit-primary`} onClick={() => {
                                                            setSelectedCertificate(certificate);
                                                            setInitialCertificate(certificate);
                                                            // setCompleteDate(convertToDate(certificate.completion_date));
                                                            // setCertificateDate(convertToDate(certificate.issued_date));
                                                            setSelectedEditStatus({ id: '', name: certificate.certificate_status })
                                                            setEditBtnDisable(false);
                                                            setErrorMsg(null);
                                                            setEditErrorMsgs({
                                                                name: '',
                                                                course_code: ''
                                                            })
                                                            setModalOpen(true);
                                                        }}><FontAwesomeIcon icon={faPen} /></button>

                                                    }
                                                    <button className={`btn-edit-label`} onClick={() => {
                                                        handleChangeStatusClick(certificate)
                                                    }}>Change Status</button>
                                                    <button className={`btn-edit-label`} onClick={() => {
                                                        getCertificateActivityLogs(certificate)
                                                    }}><LuLogs color="#000000" /></button>
                                                    {['Verified', 'Printed', 'Issued'].includes(certificate?.certificate_status) && certificate?.certificate_template_version?.version_status === 'Expired' &&
                                                        <button className={`btn-edit-label`} onClick={() => {
                                                            setSelectReprintCertificate(certificate);
                                                            setCertificateReprintModalOpen(true);
                                                        }}><LuPrinterCheck color="#000000" /></button>
                                                    }
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <NoResultsFound />
                    }
                </div>
                {isModalOpen &&
                    <div className={`modal-overlay`}>
                        <div className={`modal-card`}>
                            <div className={`modal-header`}>
                                <h4 className={`modal-title`}>Edit Certificate Details</h4>
                                <FontAwesomeIcon icon={faXmark} onClick={() => setModalOpen(false)} size="lg" cursor="pointer" />
                            </div>
                            <div className={`modal-body`} style={{ maxHeight: "70vh", overflowY: "auto" }}>
                                <div className={styles.formContainer}>
                                    <form className={styles.coordinatorForm} noValidate>

                                        {/* Document Ref - Always Visible */}
                                        <div className={`form-input-row md-col`}>
                                            <div className={`form-input-group`}>
                                                <label className={`form-label`}>
                                                    Document Ref<span className={`required-star`}>*</span>
                                                </label>
                                                <input
                                                    type='text'
                                                    name='document_ref'
                                                    value={selectedCertificate.document_ref || ''}
                                                    className={`form-input-default`}
                                                    disabled
                                                />
                                            </div>
                                        </div>

                                        {/* Dynamic Fields */}
                                        {activeHeaders.map((field) => (
                                            <div key={field} className={`form-input-row md-col`}>
                                                <div className={`form-input-group`}>
                                                    <label className={`form-label`}>
                                                        {field.replace(/_/g, " ").toUpperCase()}
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name={field}
                                                        value={selectedCertificate[field] || ""}
                                                        onChange={handleSelectedCertificateChange}
                                                        placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                        className={`form-input-default`}
                                                    />

                                                    {editErrorMsgs[field] && (
                                                        <p className={`text-danger`}>
                                                            {editErrorMsgs[field]}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        ))}

                                        <button
                                            className={`btn-primary`}
                                            type='button'
                                            disabled={disabledEditBtn}
                                            onClick={editCertificateDetails}
                                        >
                                            {isEditingCertificate ? <BeatLoader color='#ffffff' /> : `Save`}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {isActivateModalOpen && (
                    <Modal
                        title='Vehicle Activation'
                        onClose={closeModal}
                        onYes={handleYes}
                        isInput={false}
                        iconName={faCircleCheck}
                        bodyText={`Are you sure you want to activate the Vehicle?`}
                        colorType={`var(--green)`}
                    />
                )}
                {isDeactivationModalOpen && (
                    <Modal
                        title='Vehicle Deactivation'
                        onClose={closDeactivationModal}
                        onYes={handleRejectYes}
                        isInput={false}
                        iconName={faCircleXmark}
                        bodyText={`Are you sure you want to deactivate the Vehicle?`}
                        colorType={`var(--danger)`}
                    />
                )}
                {printModalOpen &&
                    <div className={`modal-overlay`}>
                        <div className={`modal-card`}>
                            <div className={`modal-header`}>
                                <h4 className={`modal-title`}>Update Certificate Status</h4>
                                <FontAwesomeIcon icon={faXmark} onClick={() => setPrintModalOpen(false)} size="lg" cursor="pointer" />
                            </div>
                            <div className={`modal-body`}>
                                <div className={styles.formContainer}>
                                    <form
                                        className={styles.coordinatorForm}
                                        noValidate
                                    >
                                        <div className={`form-input-row md-col`}>
                                            <div className={`form-input-group`}>
                                                <FilterDropdown
                                                    ref={editStatusDropdownRef}
                                                    options={certificateStatus}
                                                    placeholder="Choose a Status"
                                                    onSelect={handleSelectEditStatus}
                                                    value={selectedEditStatus.name}
                                                />
                                            </div>
                                        </div>
                                        {selectedEditStatus.name === 'Cancelled' && <div className={`form-input-row md-col`}>
                                            <div className={`form-input-group`}>
                                                <label htmlFor='full_name' className={`form-label`}>
                                                    Reason<span className={`required-star`}>*</span>
                                                </label>
                                                <input
                                                    type='text'
                                                    id='reason'
                                                    name='reason'
                                                    value={reason}
                                                    onChange={handleInputChange}
                                                    placeholder='Enter Reason'
                                                    className={`form-input-default`}
                                                />
                                                {reasonMsg && (
                                                    <p className={`text-danger`}>{reasonMsg}</p>
                                                )}
                                            </div>
                                        </div>}
                                        <button
                                            className={`btn-primary`}
                                            type='button'
                                            disabled={disabledEditBtn}
                                            onClick={editCertificateStatus}
                                        >
                                            {isEditingCertificate ? <BeatLoader color='#ffffff' /> : `Save`}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {isCertificateReprintModalOpen && (
                    <div className={`modal-overlay`}>
                        <div className={`modal-card`}>
                            <div className={`modal-header`}>
                                <h4 className={`modal-title`}>Certificate Template Version</h4>
                                <FontAwesomeIcon icon={faXmark} onClick={() => setCertificateReprintModalOpen(false)} size="lg" cursor="pointer" />
                            </div>
                            <div className={`modal-body`}>
                                <div className={styles.formContainer}>
                                    <form
                                        className={styles.coordinatorForm}
                                        noValidate
                                    >
                                        <div className={`form-input-row md-col`}>
                                            <div className={`form-input-group`}>
                                                <p>Are you sure you want to change the certificate template to current active version?</p>
                                            </div>
                                        </div>
                                        <button
                                            className={`btn-secondary`}
                                            type='button'
                                            disabled={isChanging}
                                            onClick={handleReprintYes}
                                        >
                                            {isChanging ? <BeatLoader color='#ffffff' /> : `Change Version`}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {isCertificateReprintConfirmationModalOpen && (
                    <div className={`modal-overlay`}>
                        <div className={`modal-card`}>
                            <div className={`modal-header`}>
                                <h4 className={`modal-title`}>Reprint Certificate</h4>
                                <FontAwesomeIcon icon={faXmark} onClick={() => setCertificateReprintConfirmationModalOpen(false)} size="lg" cursor="pointer" />
                            </div>
                            <div className={`modal-body`}>
                                <div className={styles.formContainer}>
                                    <form
                                        className={styles.coordinatorForm}
                                        noValidate
                                    >
                                        <div className={`form-input-row md-col`}>
                                            <div className={`form-input-group`}>
                                                <p>Are you going to reprint the certificate?</p>
                                            </div>
                                        </div>
                                        <button
                                            className={`btn-secondary`}
                                            type='button'
                                            disabled={isPrinting}
                                            onClick={handleReprintConfirmationYes}
                                        >
                                            {isPrinting ? <BeatLoader color='#ffffff' /> : `Reprint`}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div >
            {/* <PDFViewer width={800} height={1400}>
                <RCCertificate data={[certificates[3], 'qrDataUrl']} />
            </PDFViewer> */}
        </>
    );
};

export default CertificateList;
